import PropTypes from "prop-types";
import { Skeleton } from "../Skeleton";
import { Table, THead, TBody, Th, Tr, Td } from "../Table";
import clsx from "clsx";

/**
 * TableSkeleton Component
 * Displays a loading skeleton for a table with configurable rows and columns
 */
export function TableSkeleton({
  rows = 5,
  columns = 6,
  className = "",
  headerClassName = "",
  rowClassName = "",
  dense = false,
  colDense = false,
}) {
  return (
    <div className={clsx("w-full overflow-auto custom-scrollbar", className)}>
      <Table
        hoverable
        dense={dense}
        colDense={colDense}
        sticky
        className="w-full text-left rtl:text-right"
      >
        {/* Header Skeleton */}
        <THead className="!z-20 bg-white dark:bg-dark-900">
          <Tr className="bg-white dark:bg-dark-900">
            {Array.from({ length: columns }).map((_, colIndex) => (
              <Th
                key={`header-${colIndex}`}
                className={clsx(
                  "dark:bg-dark-700 dark:text-dark-100 bg-gray-200 font-semibold text-gray-800 uppercase first:ltr:rounded-tl-lg last:ltr:rounded-tr-lg first:rtl:rounded-tr-lg last:rtl:rounded-tl-lg !border-r-2 !border-white dark:!border-dark-900 last:!border-r-0",
                  headerClassName
                )}
              >
                <Skeleton className="h-4 w-24 rounded bg-gray-300 dark:bg-dark-600" />
              </Th>
            ))}
          </Tr>
        </THead>

        {/* Body Skeleton */}
        <TBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <Tr
              key={`row-${rowIndex}`}
              className={clsx(
                "dark:border-b-dark-500 border-y border-transparent border-b-gray-200",
                rowClassName
              )}
            >
              {Array.from({ length: columns }).map((_, colIndex) => (
                <Td key={`cell-${rowIndex}-${colIndex}`} className="py-3">
                  <Skeleton
                    className={clsx(
                      "h-4 rounded bg-gray-200 dark:bg-dark-700",
                      // Vary width to look more natural
                      colIndex % 3 === 0 && "w-16",
                      colIndex % 3 === 1 && "w-32",
                      colIndex % 3 === 2 && "w-24"
                    )}
                  />
                </Td>
              ))}
            </Tr>
          ))}
        </TBody>
      </Table>
    </div>
  );
}

TableSkeleton.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  rowClassName: PropTypes.string,
  dense: PropTypes.bool,
  colDense: PropTypes.bool,
};

export default TableSkeleton;
